<div class="cv-photo-sub-exterior">
	<cv-tab-group>
		<cv-tab [icon]="'fas fa-house-damage'" [tooltip]="'Deficiencies'">
			<cv-tab-group class="cv-photo-sub-exterior__paging"
										[ngClass]="{'no-paging' : deficiencies.length <= 1}">
				<cv-tab
					[active]="i === 0"
					*ngFor="let def of deficiencies; let i = index"
					[title]="deficiencies.length > 1 ? (i + 1).toString(0) : ''"
				>
					<div class="cv-photo-sub-exterior__tab-content">
						<div class="gallery-photo" *ngIf="def.cv_photos">
							<!-- <img src="{{ def.cv_photos[0].path[0].medium }}" /> -->
							<!--<ngx-gallery
								[options]="galleryOptions"
								[images]="def.cv_photos[0].path"
							></ngx-gallery>-->
							<cv-gallery [album]="def.cv_photos[0].path" [options]="options"></cv-gallery>
						</div>
						<div class="gallery-photo" *ngIf="!def.cv_photos">
							<label>No photo available</label>
						</div>
						<div class="filled-columm columm-field">
							<label>Deficiency name</label>
							<label class="columm-value">{{ def.deficiencyName || noInfo }}</label>
						</div>
						<div class="columm-field">
							<label>Deficiency type</label>
							<label class="columm-value">{{ def.deficiencyType || noInfo }}</label>
						</div>
						<div class="filled-columm columm-field">
							<label>Deficiency severity</label>
							<label class="columm-value">{{ def.exteriorDeficiencySeverity || noInfo }}</label>
						</div>
						<div class="columm-field">
							<label> Deficiency description</label>
							<label class="columm-value">{{ def.descriptionExteriorDeficiency || noInfo }}</label>
						</div>
					</div>
				</cv-tab>
			</cv-tab-group>
		</cv-tab>
		<cv-tab [icon]="'fas fa-bolt'" [tooltip]="'Mechanical Deficiencies'">
			<cv-tab-group class="cv-photo-sub-exterior__paging"
										[ngClass]="{'no-paging' : mechanical.length <= 1}">
				<cv-tab
					[active]="i === 0"
					*ngFor="let mech of mechanical; let i = index"
					[title]="mechanical.length > 1 ? (i + 1).toString(0) : ''"
				>
					<div class="cv-photo-sub-exterior__tab-content">
						<div class="gallery-photo" *ngIf="mech.cv_photos">
							<!--<ngx-gallery
								[options]="galleryOptions"
								[images]="mech.cv_photos[0].path"
							></ngx-gallery>-->
							<cv-gallery [album]="mech.cv_photos[0].path" [options]="options"></cv-gallery>
						</div>
						<div class="gallery-photo" *ngIf="!mech.cv_photos">
							<label>No photo available</label>
						</div>
						<div class="filled-columm columm-field">
							<label>Mechanical name</label>
							<label class="columm-value">{{ mech.deficiencyName || noInfo }}</label>
						</div>
						<div class="columm-field">
							<label>Mechanical type</label>
							<label class="columm-value">{{ mech.deficiencyType || noInfo }}</label>
						</div>
						<div class="filled-columm columm-field">
							<label>Mechanical severity</label>
							<label class="columm-value">{{ mech.mechanicalDeficiencySeverity || noInfo }}</label>
						</div>
						<div class="columm-field">
							<label> Mechanical description</label>
							<label class="columm-value">{{
								mech.descriptionMechanicalDeficiency || noInfo
							}}</label>
						</div>
					</div>
				</cv-tab>
			</cv-tab-group>
		</cv-tab>
		<cv-tab [icon]="'fas fa-wrench'" [tooltip]="'Updates'">
			<cv-tab-group class="cv-photo-sub-exterior__paging"
										[ngClass]="{'no-paging' : updates.length <= 1}">
				<cv-tab
					[active]="i === 0"
					*ngFor="let upt of updates; let i = index"
					[title]="updates.length > 1 ? (i + 1).toString(0) : ''"
				>
					<div class="cv-photo-sub-exterior__tab-content">
						<div class="gallery-photo" *ngIf="upt.cv_photos">
							<!--<ngx-gallery
								[options]="galleryOptions"
								[images]="upt.cv_photos[0].path"
							></ngx-gallery>-->
							<cv-gallery [album]="upt.cv_photos[0].path" [options]="options"></cv-gallery>
							
						</div>
						<div class="gallery-photo" *ngIf="!upt.cv_photos">
							<label>No photo available</label>
						</div>
						<div class="filled-columm columm-field">
							<label>Updated component</label>
							<label class="columm-value">{{ upt.exteriorUpdatedComponent || noInfo }}</label>
						</div>
						<div class="columm-field">
							<label>Updated type</label>
							<label class="columm-value">{{ upt.exteriorUpdateType || noInfo }}</label>
						</div>
						<div class="filled-columm columm-field">
							<label>Update timeframe</label>
							<label class="columm-value">{{ upt.exteriorUpdateTimeframe || noInfo }}</label>
						</div>
						<div class="columm-field">
							<label> Update description</label>
							<label class="columm-value">{{ upt.exteriorUpdateDescription || noInfo }}</label>
						</div>
					</div>
				</cv-tab>
			</cv-tab-group>
		</cv-tab>
		<cv-tab [icon]="'fas fa-star'" [tooltip]="'Features'">
			<cv-tab-group class="cv-photo-sub-exterior__paging"
										[ngClass]="{'no-paging' : features.length <= 1}">
				<cv-tab
					[active]="i === 0"
					*ngFor="let ft of features; let i = index"
					[title]="features.length > 1 ? (i + 1).toString(0) : ''"
				>
					<div class="cv-photo-sub-exterior__tab-content">
						<div class="gallery-photo" *ngIf="ft.cv_photos">
							<!--<ngx-gallery [options]="galleryOptions" [images]="ft.cv_photos[0].path"></ngx-gallery>-->
							<cv-gallery [album]="ft.cv_photos[0].path" [options]="options"></cv-gallery>
						</div>
						<div class="gallery-photo" *ngIf="!ft.cv_photos">
							<label>No photo available</label>
						</div>
						<div class="filled-columm columm-field">
							<label>Features Type</label>
							<label class="columm-value">{{ ft.exteriorFeatureType }}</label>
						</div>
					</div>
				</cv-tab>
			</cv-tab-group>
		</cv-tab>
	</cv-tab-group>
</div>
